// extracted by mini-css-extract-plugin
export var content = "_bq-3";
export var list = "_bq-4";
export var settingsContent = "_bq-7";
export var settingsPanel = "_bq-8";
export var state = "_bq-6";
export var triggerBadge = "_bq-2";
export var triggerButton = "_bq-1";
export var triggerShell = "_bq-0";
export var unreadDot = "_bq-5";